/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CopiaLavoroMassivoRequestDTO
 */
export interface CopiaLavoroMassivoRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof CopiaLavoroMassivoRequestDTO
     */
    idLavoro?: number;
    /**
     * 
     * @type {Array<Date>}
     * @memberof CopiaLavoroMassivoRequestDTO
     */
    dateDestinazione?: Array<Date> | null;
}

/**
 * Check if a given object implements the CopiaLavoroMassivoRequestDTO interface.
 */
export function instanceOfCopiaLavoroMassivoRequestDTO(value: object): value is CopiaLavoroMassivoRequestDTO {
    return true;
}

export function CopiaLavoroMassivoRequestDTOFromJSON(json: any): CopiaLavoroMassivoRequestDTO {
    return CopiaLavoroMassivoRequestDTOFromJSONTyped(json, false);
}

export function CopiaLavoroMassivoRequestDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CopiaLavoroMassivoRequestDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idLavoro': json['idLavoro'] == null ? undefined : json['idLavoro'],
        'dateDestinazione': json['dateDestinazione'] == null ? undefined : json['dateDestinazione'],
    };
}

export function CopiaLavoroMassivoRequestDTOToJSON(json: any): CopiaLavoroMassivoRequestDTO {
    return CopiaLavoroMassivoRequestDTOToJSONTyped(json, false);
}

export function CopiaLavoroMassivoRequestDTOToJSONTyped(value?: CopiaLavoroMassivoRequestDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idLavoro': value['idLavoro'],
        'dateDestinazione': value['dateDestinazione'],
    };
}

